import * as actions_admin from 'actions/admin-actions';
import * as actions_attachments from 'actions/attachments-actions';
import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import moment from 'moment';
import { FormBuilder, ValidateForm, ModalForm } from 'enspire-manager-framework';
import { ACTION } from 'components/constants';
import { attachment_fields, attachment_form_layout } from './attachment-form-layout';
import { confirmDelete } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
// import { Dropzone } from 'components/test/dropzone';

var _ = require('lodash');

export default function AttachmentForm(props) {

	const params = useParams();
	const history = useHistory();
	const dispatch = useDispatch();

	const admin = useSelector((store) => store.admin);
    const table = useSelector((store) => store[props.store]);
	const user_permissions = useSelector(store => store.users?.user_permissions);

	const isNew = (params.attachment_name == '0' || params.form_id == '0');
	const field = (props.field) ? props.field : 'attachments';
    const attachments = table?.[props.singular + '_' + field] ?? [];
	const attachment = attachments.find(attach => attach.name === params.attachment_name || attach.name === params.form_id);
    const defaultAttach = (props.defaultAttach) ? props.defaultAttach : [];

	const [focusedInput, setFocused] = useState(null);
	const [original, setOriginal] = useState({});
	const [state, setState] = useState({
		search: '',
		form_error: null,
		attachment: attachment_fields(),
		expand: false,
	});

    // Permissions ----------------------------------------

    const canView = props.permissions?.canView;
    const canEdit = props.permissions?.canEdit;

	/* Effects -----------------------------------------------------------------------------------------------------------------------*/

	useEffect(() => {
		if (props.filter) setState(prev => ({ ...prev, attachment: { ...prev.attachment, classificationId: props.filter } }));
	}, [props?.filter]);

	useEffect(() => {
		if (params.attachment_name != '0') {
			populateForm();
		}
	}, [params.form_id, attachment]);

	/* Handlers --------------------------*/

	const handleChange = (e, value) => {
		let newValue = (value) ? value : e.target.value;
		let form_error = _.filter(state.form_error, (o) => { return o.field !== e.target.name; });
		setState(prev => ({ ...prev, form_error, attachment: { ...prev.attachment, [e.target.name]: newValue } }));
	};
    const handleDate = (field, date) => {
        let form_error = _.filter(state.form_error, (o) => { return o.field !== field; });
        setState(prev => ({ ...prev, form_error, attachment: { ...prev.attachment, [field]: moment(date).toDate() }}));
    };
    const handleClear = (field) => {
        let form_error = _.filter(state.form_error, (o) => { return o.field !== field; });
        setState(prev => ({ ...prev, form_error, attachment: { ...prev.attachment, [field]: null }}));
    };
	const handleUpload = (field, upload, caption) => {
		if (caption != null) {
			setState(prev => ({ ...prev, attachment: { ...prev.attachment, [field + '_caption']: caption } }));
		} else {
			let results = actions_attachments.prepUploadedImages(field, upload, state.attachment);
			setState(prev => ({ ...prev, attachment: results }));
		}
	};
	const handleReorder = (field) => {
		var myAttachment = { ...state.attachment };
		let elementIndex = parseInt(field.split('imageUrl')[1]);
		let previousIndex = elementIndex - 1;
		let previous = myAttachment.images[previousIndex];
		myAttachment.images[previousIndex] = myAttachment.images[elementIndex];
		myAttachment.images[elementIndex] = previous;

		attachment.images?.forEach((image, index) => {
			myAttachment['imageUrl' + index] = image.imageUrl;
			myAttachment['imageUrl' + index + '_caption'] = image.caption ?? '';
		});	
        setState(prev => ({ ...prev, attachment: { ...myAttachment }}));
	}

	/* Actions --------------------------*/

	const populateForm = async () => {
		if (attachment) {
			let myAttachment = { ...attachment,
				expiration: (attachment.expiration) ? moment(attachment.expiration?.seconds, 'X').toDate() : null,
			};
			const images = attachment.images;
			images?.forEach((image, index) => {
				myAttachment['imageUrl' + index] = image.imageUrl;
				myAttachment['imageUrl' + index + '_caption'] = image.caption ?? '';
			});	
			setState(prev => ({ ...prev, attachment: myAttachment }));
			setOriginal(myAttachment);
		} else {
			state.attachment.name = params.attachment_name;
		}
	};		
    const handleDelete = () => {
		var attachmentsArray = [];
		attachments.forEach((attach, index) => {
			if (attach.name != original.name) attachmentsArray.push(attach);
		});
		dispatch(actions_attachments.attachmentSpinner(true));
		dispatch(actions_attachments.saveAttachment(params.handle, props.id, attachmentsArray, props.source, props.prefix, field, (assetId) => {
			dispatch(actions_admin.saveActivity(params.handle, props.prefix, ACTION.DELETED.key, props.id, `Attachment: ${state.attachment.name}`));
			dispatch(actions_attachments.attachmentSpinner(false));
			history.goBack();
		}));
    };

	const submitForm = (assetFormLayout) => {
		var form_error = ValidateForm(state.attachment, assetFormLayout);
		setState(prev => ({ ...prev, form_error }));

		let existing = attachments.find(attach => attach.name === state.attachment.name);
		if (existing && existing.name != original .name) {
			window.toastr.error(`An Attachment with this name already exists`, `Duplicate Name`);
			return;
		}

		let myAttachment = { ...state.attachment };
		let images = [];
		for (let index = 0; index < 10; index++) {
			if (state.attachment['imageUrl' + index]) images.push({ 
				...myAttachment.images[index], // caption, dimensions, type
				imageUrl: state.attachment['imageUrl' + index],
				caption: state.attachment['imageUrl' + index + '_caption'],
			});
			delete myAttachment['imageUrl' + index]
			delete myAttachment['imageUrl' + index + '_caption']
		}
		myAttachment.images = images;

		var attachmentsArray = [];	
		if (params.attachment_name == '0' || params.form_id == '0') {
			attachmentsArray = [ ...attachments, myAttachment];
		} else {
			attachments.forEach((attach, index) => {
				if (attach.name == original.name) {
					attachmentsArray.push(myAttachment);
				} else {
					attachmentsArray.push(attach);
				}
			});
		}

		if (!form_error.length) {
			dispatch(actions_attachments.attachmentSpinner(true));
			dispatch(actions_attachments.saveAttachment(params.handle, props.id, attachmentsArray, props.source, props.prefix, field, (id) => {
				dispatch(actions_admin.saveActivity(params.handle, props.prefix, (isNew) ? ACTION.CREATED.key : ACTION.MODIFIED.key, props.id, `Attachment: ${state.attachment.name}`));
				dispatch(actions_attachments.attachmentSpinner(false));
				history.goBack();
				if (props.field == 'external_invoices' && isNew) history.goBack(); // 2nd time exits Line Item Builder
			}));
		}
	};

	const isDefault = defaultAttach.some(attach => attach.name === state.attachment.name);
	const form_layout = attachment_form_layout({
		attachment: state.attachment, 
		expires: props.expires,
		firebase, 
		handle: params.handle, 
		handleReorder,
		invoice: props.invoice,
		isDefault,
	});

	return (

		<ModalForm {...props}
			history={history}
			style={1}
			size={'md'}
			modal_header={`Attachment`}
			cancel_button_title="Cancel"
			save_button_title={'Save Details'}
			submitFormHandler={() => submitForm(form_layout)}
			delete_button_title={'Delete'}
			delete_button_disabled={ isNew }
			delete_button_callback={(isNew) ? null : () => confirmDelete('Asset', handleDelete)}
			show_spinner={admin.attachments_spinner}
			focusedInput={(window.flutter) ? focusedInput : null}
			platform={admin.flutter_platform}
			keyboardPadding={admin.flutter_keyboard}
		>
			{/* Leave this here for testing purposes */}
			{/* <Dropzone
				bin={params.handle}
				camera={true}
				directory={'assets'}
				field={'imageUrl'}
				image={(state.attachment['imageUrl']) ? state.attachment['imageUrl'] : ''}
				hasCaption={true}
				caption={(state.attachment['imageUrl_caption']) ? state.attachment['imageUrl_caption'] : ''}
				multiple={true}
				onChange={handleUpload}
				onPromote={handleReorder}
				storage={'firebase'}
				storageRef={firebase.storage().ref()}
			/> */}

			{state.attachment &&
				<FormBuilder
					callbacks={{
						focus: (event) => setFocused(event.target),
						text: handleChange,
						select: handleChange,
						dropzone: handleUpload,
						date: handleDate,
						clear: handleClear,
					}}
					form_error={state.form_error}
					form={form_layout}
					record={state.attachment}
				/>
			}
		</ModalForm>
	);
}